/* eslint-disable no-redeclare */
import React from 'react';
import * as Sentry from '@sentry/browser';
import DocumentNodeForm from 'routes/surface/components/node-modal-form/components/background-node-modal/components/document-node-form';
import UploadFileForm from 'routes/surface/components/node-modal-form/components/background-node-modal/components/document-node-form/components/upload-file-form';
import ImageNodeForm from 'routes/surface/components/node-modal-form/components/image-node-modal/components/image-node-form';
import If from 'components/if-statement';
import useSaveSurfaceBackgroundNode from 'routes/surface/components/node-modal-form/hooks/use-save-surface-background-node';
import useSaveNodeInCache from 'components/canvas/hooks/use-save-node-in-cache';
import useFileToLocalUrl from 'hooks/use-file-to-local-url';
import { useUploadSurfaceNodeFile } from 'components/canvas/hooks/use-upload-surface-node-file';
import { useTranslation } from 'i18n';
import { withModal } from 'hoc';
import { asyncAction } from 'utils/js';
import { set } from 'lodash/fp';
import { toast } from 'services/toast';
import { ModalContext } from 'hoc/with-modal';
import {
  SurfaceBackgroundNode,
  SurfaceDocumentNode,
  SurfaceDocumentNodeFormat,
  SurfaceImageNodeFormat,
  SurfaceNodeType,
} from 'graphql/types';
import { NodeModalInput } from 'types';
import axios from 'axios';

export interface DocumentNodeModalContentProps {
  data: NodeModalInput<SurfaceBackgroundNode>;
  modal: ModalContext;
  onFileChange?: Function;
}

function BackgroundNodeModalContent(props: DocumentNodeModalContentProps) {
  const { data } = props;
  const { t } = useTranslation();

  // @ts-ignore
  const surfaceId = data.surface?.id ?? data.surface;

  const [shouldShowFilePreview, setShowFilePreview] = React.useState(
    Boolean(data.id),
  );

  const [file, setFile] = React.useState<File | undefined>();
  const [size, setSize] = React.useState<any | undefined>(undefined);
  const [name, setName] = React.useState<string>('');
  const fileUrl = useFileToLocalUrl(file);

  const saveSurfaceImageNode = useSaveSurfaceBackgroundNode(surfaceId);
  const uploadFile = useUploadSurfaceNodeFile(surfaceId);
  const saveNodeInCache = useSaveNodeInCache();

  async function onSubmit(input, { setSubmitting }) {
    const saveOperation = saveSurfaceImageNode;

    console.warn('XXXX1', input.file);
    console.warn('XXXX2 url', input.url);

    let file_input = input.file;

    if (file_input && file_input.url) {
      console.warn('XXXX2 url FETCH ', file_input);
      let myBlob = (
        await axios.get(file_input.url, {
          responseType: 'blob',
          headers: {
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache',
            Expires: '0',
          },
          // withCredentials : true,
          // headers: {
          //   "Origin":"http://my.cortlex.at"
          // }
        })
      ).data;
      file_input = new File([myBlob], 'name', { type: 'image/jpg' });

      console.warn('BLOBS ', file_input);
      // file.
    }

    const response = await saveOperation({ variables: { input } });

    if (response.isFailure) {
      setSubmitting(false);
      toast.error(response.getErrorMessage());

      return response;
    }

    const node = response.getField('data');

    // let file = input.file;

    if (file_input.img) {
      console.warn('XXXX2 url FETCH ', file_input);
      let myBlob = (
        await axios.get(file_input.img, {
          responseType: 'blob',
        })
      ).data;
      file_input = new File([myBlob], 'name', { type: 'image/jpg' });

      console.warn('BLOBS ', file_input);
      // file.
    }

    // Upload a file  then set correct values and submit data
    const [error] = await asyncAction(uploadFile(file_input, node.id));

    if (error) {
      Sentry.captureException(error);
    }

    saveNodeInCache(set('updatedAt', new Date().toISOString(), node));

    return response;
  }

  function onFileChange(file) {
    setFile(file);
    console.log('FILE ', file);
    var url = '';
    if (file.url) {
      url = file.url;
    } else {
      url = URL.createObjectURL(file);
    }
    var img: HTMLImageElement;
    img = document.createElement('img');

    img.onload = function (event: any) {
      console.log('ON LOAD ', event, {
        width: event.width,
        height: event.height,
      });
    };

    img.src = url;
    console.log('XXXX  Fiel changed ', file, url);

    let img2 = new Image();
    img2.onload = function (event) {
      console.log('Image Width: 22 ', event, img2.width, img2.height);
      setSize({ width: img2.width, height: img2.height });
    };
    img2.src = url;
    props.onFileChange && props.onFileChange(file);
  }

  function onNameChange(name) {
    setName(name);
  }

  function showFilePreview() {
    setShowFilePreview(true);
  }

  function getFileFormat(file): string | undefined {
    if (file?.type.includes('pdf')) {
      return SurfaceDocumentNodeFormat.Pdf;
    }

    if (file?.type.includes('jpg')) {
      return SurfaceImageNodeFormat.Jpg;
    }

    if (file?.type.includes('jpeg')) {
      return SurfaceImageNodeFormat.Jpeg;
    }

    if (file?.type.includes('png')) {
      return SurfaceImageNodeFormat.Png;
    }
  }

  function getNodeTypeForFile(file): string | undefined {
    if (file) {
      if (file?.type.includes('pdf')) {
        return SurfaceNodeType.Document;
      }
      return SurfaceNodeType.Image;
    }

    return undefined;
  }

  function backButtonRenderer(BackButton) {
    if (data.id) {
      return null;
    }

    return (
      <BackButton onClick={() => setShowFilePreview(false)}>
        {t('Back to file upload')}
      </BackButton>
    );
  }

  const type = getNodeTypeForFile(file) ?? data?.type;

  const initialValues = {
    ...data,
    file,
    name: name || data.name,
    format: getFileFormat(file),
    size: size
      ? size
      : { width: data?.size?.width, height: data?.size?.height },
    ...(file ? { type, url: fileUrl } : {}),
  } as NodeModalInput<SurfaceDocumentNode>;

  return (
    <If condition={shouldShowFilePreview}>
      <If.Then>
        <If condition={type === SurfaceNodeType.Document}>
          <If.Then>
            <DocumentNodeForm
              initialValues={initialValues}
              onSubmit={onSubmit}
              closeForm={props.modal.hide}
              backButton={backButtonRenderer}
            />
          </If.Then>
          <If.Else>
            <ImageNodeForm
              initialValues={initialValues}
              onSubmit={onSubmit}
              onCancel={props.modal.hide}
              backButton={backButtonRenderer}
            />
          </If.Else>
        </If>
      </If.Then>
      <If.Else>
        <UploadFileForm
          accept={['jpg', 'png', 'jpeg']}
          onNameChange={onNameChange}
          onFileChange={onFileChange}
          onCancel={props.modal.hide}
          onSubmit={showFilePreview}
        />
      </If.Else>
    </If>
  );
}

export default withModal(BackgroundNodeModalContent);
